import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IPortfolioItem } from '@easy-lib/modules/portfolio/models/portfolio-item.model';

export const PortfolioAction = createActionGroup({
	source: 'Portfolio',
	events: {
		loaderStart: emptyProps(),
		loaderEnd: emptyProps(),
		errorLoaded: emptyProps(),
		subscribeToPerformanceLS: emptyProps(),
		load: emptyProps(),
		upsert: props<{ items: IPortfolioItem[] }>(),
		loaded: emptyProps()
	}
});
